let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7cwm9")).then(() => parcelRequire('5NaVN'));